import React from 'react';
import {
  Alert,
  Box,
  Button,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import AndroidIcon from '@mui/icons-material/Android';
import { FullscreenFillContainer } from './ContentFullscreenFrame';

const STUDENT_ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.knls.academy';

export default function AndroidOnlyDocumentNotice() {
  return (
    <FullscreenFillContainer>
      <Paper elevation={1} sx={{ p: 3 }}>
        <Stack spacing={2}>
          <Alert severity="warning">
            PDF and image files are available only in the Android app.
          </Alert>
          <Typography variant="body2" color="text.secondary">
          To protect course content, documents and images are not shown on the website. Please install or
          open the KNLS Android app to view this file.
          </Typography>
          <Box>
            <Button
              variant="contained"
              color="primary"
              href={STUDENT_ANDROID_APP_URL}
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<AndroidIcon />}
            >
              Install / Open Android App
            </Button>
          </Box>
        </Stack>
      </Paper>
    </FullscreenFillContainer>
  );
}

export function PdfAppOnlyAlert() {
  return (
    <Alert
      severity="warning"
      action={(
        <Button
          component="a"
          href={STUDENT_ANDROID_APP_URL}
          target="_blank"
          rel="noopener noreferrer"
          size="small"
          color="inherit"
          startIcon={<AndroidIcon />}
        >
          Install App
        </Button>
      )}
    >
      Original PDF document is available only in the KNLS Android app.
    </Alert>
  );
}
